import { Location } from "vue-router";
import { MutationTree } from "vuex";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import { LoginResponse } from "@scrile/api-provider/dist/api/LoginProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { MUTATION_TYPES } from "@/store/const";
import { setLoginData, removeLoginData } from "@/lib/authHelper";
import { StateRoot } from "./state";

export const mutations: MutationTree<StateRoot> = {
  [MUTATION_TYPES.SET_LOGIN_DATA]: (state, { user, authorities }: Pick<LoginResponse, "user" | "authorities">) => {
    state.user = user;
    state.authorities = authorities || [];
    setLoginData({ user, authorities });
  },
  [MUTATION_TYPES.SET_VERIFICATION_STATUS]: (state, payload: boolean) => {
    if (state.user) {
      state.user = {
        ...state.user,
        emailVerified: payload,
      };
      setLoginData({ user: state.user, authorities: state.authorities });
    }
  },
  [MUTATION_TYPES.SET_USER_VERIFICATION_STATUS]: (state, payload: UserVerificationStatus) => {
    state.verified = payload;
  },
  [MUTATION_TYPES.SET_USER]: (state, payload: User) => {
    state.user = {
      ...payload,
      emailVerified: state.user?.emailVerified,
    };
  },
  [MUTATION_TYPES.LOGOUT]: state => {
    state.user = null;
    state.verified = UserVerificationStatus.UNVERIFIED;
    state.authorities = [];
    state.socialLogin = false;
    state.redirectPath = null;
    removeLoginData();
  },
  [MUTATION_TYPES.SET_SOCIAL_LOGIN]: (state, payload: boolean) => {
    state.socialLogin = payload;
  },
  [MUTATION_TYPES.SET_REDIRECT_PATH]: (state, payload: Location | null) => {
    state.redirectPath = payload;
  },
  [MUTATION_TYPES.SET_DO_NOT_DISTURB]: (state, payload: boolean) => {
    state.doNotDisturb = payload;
  },
  [MUTATION_TYPES.SET_USER_BALANCE]: (state, payload: number) => {
    state.userBalance = payload;
  },
  [MUTATION_TYPES.SET_STATE]: (state, payload: Partial<StateRoot>) => {
    for (const k of Object.keys(state)) {
      const key = (k as any) as keyof StateRoot;
      (state as any)[key] = payload[key] !== undefined ? payload[key] : state[key];
    }
  },
  [MUTATION_TYPES.SET_DARK_MODE]: (state, payload: StateRoot["darkMode"]) => {
    state.darkMode = payload;
  },
  [MUTATION_TYPES.SET_AGE_VERIFICATION_STATUS]: (state, payload: AgeVerificationStatus) => {
    state.ageVerificationStatus = payload;
  },
};
